<template>
  <div>
    <v-alert
      v-if="!canManage"
      type="info"
      dense
      icon="mdi-account-wrench"
      class="mb-0"
    >
      As configurações deste evento só podem ser alteradas por técnicos. Entre
      em contato com o suporte para solicitar uma alteração.
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TecnicianOnlyMessage",
  props: {
    party: {
      type: Object | null,
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    technicians() {
      if (!this.party) return false;
      return this.party?.Technicians.map((technician) => technician.User);
    },
    canManage() {
      if (!this.technicians) return this.user.MasterPermission;

      return this.technicians.some(
        (technician) => technician.id === this.user.id
      );
    },
  },
};
</script>
